<div class="d-flex flex-column justify-content-center align-items-center h-25 my-5" >
  <div class="my-2 message" *ngIf="message">{{message}}</div>
  <div class="spinner-border text-dark spinner my-2" role="status">
    <span class="sr-only">Chargement en cours ...</span>
  </div>
</div>

